import { apiSlice } from "../../../../../Store/api/apiSlice";
import { CoordinatesRequest, GenerationDetails, JWT } from "./generationModels";

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    generateGenerationJWT: build.mutation<JWT, GenerationDetails>({
      query: (generationDetails) => ({
        url: "/Auth/generateGenerationJWT",
        method: "POST",
        body: generationDetails,
      }),
    }),
    createGenerationSession: build.mutation<void, JWT>({
      query: (jwt) => ({
        url: "/Auth/createProxySession",
        method: "POST",
        body: jwt,
      }),
      invalidatesTags: ["Auth"],
    }),
    getEvacuationLocationsByProgramEventId: build.query<any, string>({
      query: (programEventId) => ({
        url: `/programEvacuationOrderLocationsByProgramEventId/${programEventId}`,
      }),
    }),
    getAllPrograms: build.query<any, void>({
      query: () => ({
        url: `/program/all`,
      }),
    }),
    IsPointInEvacuationZone: build.mutation<boolean, CoordinatesRequest>({
      query: (coords) => ({
        url: "/arcGIS/isPointInEvacuationZone",
        method: "POST",
        body: coords,
      }),
    }),
    getEligibleEvacuationCoordinates: build.query<any, void>({
      query: () => ({
        url: `/arcGIS/getEligibleEvacuationCoordinates`,
      }),
    }),
    getArcGISToken: build.query<any, void>({
      query: () => ({
        url: `/arcGIS/retrieveToken`,
      }),
    }),
    clearSession: build.query<void, void>({
      query: () => ({
        url: `/Auth/clearSession`,
      }),
    }),
  }),
});

// Extra api methods added not available in base apiSlice
export const {
  useGenerateGenerationJWTMutation,
  useCreateGenerationSessionMutation,
  useGetRefDataListQuery,
  useGetProgramEventListQuery,
  useGetEvacuationLocationsByProgramEventIdQuery,
  useGetAllProgramsQuery,
  useGetEligibleEvacuationCoordinatesQuery,
  useGetArcGISTokenQuery,
  useGetProgramQuery,
  useLazyClearSessionQuery,
} = extendedApiSlice;

// Re-exported methods and variables from apiSlice.
export {
  selectRefData,
  selectRefDataLoaded,
  selectRefDataLoading,
} from "../../../../../Store/api/refData/refDataSelectors";

export {
  selectProgramEventListRaw,
  selectProgramEventListLoaded,
  selectProgramEventListLoading,
  selectProgramEventList,
} from "../../../../../Store/api/programEvent/programEventSelectors";

export { useGetSessionQuery } from "../../../../../Store/api/apiSlice";

export { selectProgram } from "../../../../../Store/api/program/programSelectors";
